import './form-vehicle-transaction.scss';

import { VehicleTransactionFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = VehicleTransactionFormSchema;
export function FormVehicleTransaction() {
  const { control } = useFormContext<VehicleTransactionFormSchema>();
  return (
    <div id="FormVehicleTransaction" className="vehicle-transaction">
      <InputControl<InputFormSchema>
        control={control}
        name="tenant"
        label="Tenant"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter tenant"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="vehicle"
        label="Vehicle"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter vehicle"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="transaction"
        label="Transaction"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter transaction"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="userCode"
        label="User Code"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter userCode"
      />
    </div>
  );
}

export default FormVehicleTransaction;